// requests.ts

import axios from 'axios';
import Cookies from 'universal-cookie';
import { apiRoute } from '../../constants/api-constants';

type DataResponse = unknown;
type DataResponseArray = unknown[];

const baseURL = apiRoute;

const getAuthHeaders = () => {
  const cookies = new Cookies();
  const token = cookies.get('authorization_token');

  return token ? { Authorization: `Bearer ${token}` } : {};
};
// || 'http://localhost:8000/api';

// Fetch a specific item by its ID
export const fetchItemById = async (
  slug: string,
  id: number
): Promise<DataResponse> => {
  const { data } = await axios.get(`${baseURL}/${slug}/${id}`, {
    headers: getAuthHeaders(),
  });

  return data;
};

// Fetch all items
export const fetchAllItems = async (
  slug: string,
  limit?: number,
  queryParams?: Record<string, string | number>
): Promise<DataResponseArray> => {
  const params = new URLSearchParams();
  if (limit) {
    params.set('limit', String(limit));
  }
  if (queryParams) {
    Object.entries(queryParams).forEach(([k, v]) => params.set(k, String(v)));
  }
  const queryString = params.toString();
  const url = `${baseURL}/${slug}${queryString ? `?${queryString}` : ''}`;
  const { data } = await axios.get(url, { headers: getAuthHeaders() });

  return data;
};

// Create a new item
export const createItem = async (
  slug: string,
  data: object
): Promise<DataResponse> => {
  const { data: responseData } = await axios.post(`${baseURL}/${slug}`, data, {
    headers: getAuthHeaders(),
  });

  return responseData;
};

// Update an existing item
export const updateItem = async (
  slug: string,
  data: object,
  id: number
): Promise<DataResponse> => {
  const { data: responseData } = await axios.put(
    `${baseURL}/${slug}/${id}`,
    data,
    { headers: getAuthHeaders() }
  );

  return responseData;
};

// Update property or user item
export const updatePropertyOrUserItem = async (
  slug: string,
  data: object
): Promise<DataResponse> => {
  const { data: responseData } = await axios.put(`${baseURL}/${slug}`, data, {
    headers: getAuthHeaders(),
  });

  return responseData;
};
